import { render, staticRenderFns } from "./HotelComponent.vue?vue&type=template&id=98ba35c0&scoped=true&"
import script from "./HotelComponent.vue?vue&type=script&lang=js&"
export * from "./HotelComponent.vue?vue&type=script&lang=js&"
import style0 from "./HotelComponent.vue?vue&type=style&index=0&id=98ba35c0&lang=scss&scoped=true&"
import style1 from "./HotelComponent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./HotelComponent.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba35c0",
  null
  
)

export default component.exports